import {track} from '@malt/tracking';
import store from '@/brief-hub/store';
import {RouteLocationNormalized} from 'vue-router';

export class BriefTrackingService {
    triggerBriefFunnelStepEnteredAmplitudeEvent(
        stepName: string,
        stepNumber: number,
        route: RouteLocationNormalized,
        vertical: 'regular' | null = 'regular',
    ): void {
        const clonedBrief = {...store.getters.brief};
        const briefOrigin = route.query.brief_origin;
        const redirectionReason = route.query.redirection_reason;

        if (clonedBrief) {
            delete clonedBrief.id;
            delete clonedBrief.ref;
            delete clonedBrief.links;
        }

        track('brief_funnel_step_viewed', {
            vertical: vertical,
            step_number: stepNumber,
            step_name: stepName || 'unknown',
            ...(clonedBrief ? {brief: clonedBrief} : {}),
            brief_funnel_id: store.getters.briefFunnelId,
            ...(briefOrigin ? {brief_origin: briefOrigin} : {}),
            ...(redirectionReason ? {redirection_reason: redirectionReason} : {}),
        });
    }
}
